<div class="game-icon" 
    [ngStyle]="{
        'background': gradientStyle,
        'width': sizeCss,
        'height': sizeCss
    }">
    <img [src]="src" alt="{{ game }} icon" />
</div>
